import { useState, useEffect } from "react";
import { Form } from "reactstrap";
import { APIMS } from "../../../../../../../../config/apims";
import { APISD } from "../../../../../../../../config/apisd";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../../../index.css";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

/* ===========================
   CSS
=========================== */
const css = `
  .tingkatan-kelas-wrapper {
    margin-top: 8px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px 35px;
  }

  .tingkatan-box {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .tingkatan-parent {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
  }

  .kelas-child-wrapper {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    gap: 7px;
  }

  .kelas-child {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;
  }

  .tingkatan-parent input,
  .kelas-child input {
    width: 14px;
    height: 14px;
    cursor: pointer;
  }

  /* TABLET / HP */
  @media (max-width: 768px) {
    .tingkatan-kelas-wrapper {
      grid-template-columns: repeat(2, 1fr);
      gap: 14px 20px;
    }
  }

  /* HP KECIL BANGET */
  @media (max-width: 380px) {
    .tingkatan-kelas-wrapper {
      grid-template-columns: 1fr;
      gap: 14px;
    }
  }

    .kelas-child.disabled-kelas {
    opacity: 0.55;
    cursor: not-allowed;
  }

  .kelas-child.disabled-kelas input {
    cursor: not-allowed;
  }

  .badge-sudah-terdaftar {
    margin-left: 6px;
    padding: 2px 7px;
    border-radius: 999px;
    background: #fee2e2;
    color: #b91c1c;
    font-size: 10px;
    font-weight: 600;
  }

  .matpel-grade-panel {
    margin-top: 8px;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 15px;
    background: #f8fafc;
  }

  .matpel-form-helper {
    margin-top: 7px;
    color: #64748b;
    font-size: 12px;
    line-height: 1.5;
  }

  .tingkatan-box {
    border: 1px solid #e5eaf1;
    border-radius: 12px;
    padding: 12px;
    background: #ffffff;
  }

  .tingkatan-parent {
    color: #1e293b;
    font-weight: 700;
  }

  .kelas-child {
    color: #475569;
  }

  .tingkatan-parent input,
  .kelas-child input {
    accent-color: #3f5bea;
  }

  @media (max-width: 576px) {
    .tingkatan-kelas-wrapper {
      grid-template-columns: 1fr;
    }

    .matpel-grade-panel {
      padding: 12px;
    }
  }

`;

export default function ModalMataPelajaran(props) {
  const token = localStorage.getItem("token");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  const ascending = 1;
  const page = 1;
  const limit = 1000;

  const storageLevel = localStorage.getItem("level") || "developer";

  const [getDataCabang, setGetDataCabang] = useState([]);
  const [getDataMatpel, setGetMatpel] = useState([]);
  const [gradeLevels, setGradeLevels] = useState([]);
  const [kelasList, setKelasList] = useState([]);

  let fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const id_user = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [form, setForm] = useState({
    ysb_branch_id: "",
    name_matpel: "",
    ysb_school_id: "",
    ysb_grade_level_id: [],
    ysb_kelas_id: [],
    user_id: "",
  });

  const { name_matpel, ysb_branch_id, ysb_grade_level_id, ysb_kelas_id } = form;

  const GetResponseCabang = async () => {
    try {
      const response = await APIMS.get(
        `/api/branches?page=1&limit=1000&ascending=${ascending}&search=`,
        fetchParams
      );

      setGetDataCabang(response?.data?.data || []);
    } catch (error) {
      console.error("Gagal mengambil data cabang:", error);
      setGetDataCabang([]);
    }
  };

  // const GetResponseMatpels = async () => {
  //   try {
  //     // const response = await APISD.get(
  //     //   `/api/matpels?page=1&limit=1000&ascending=${ascending}&search=&ysb_branch_id=${form.ysb_branch_id}`,
  //     //   fetchParams
  //     // );
  //      const response = await APISD.get(
  //           `/api/matpels?page=1&limit=1000&ascending=${ascending}&search=&ysb_branch_id=${form.ysb_branch_id}`,
  //           fetchParams
  //         );
      

  //     setGetMatpel(response?.data?.data || []);
  //   } catch (error) {
  //     console.error("Gagal mengambil data matpel:", error);
  //     setGetMatpel([]);
  //   }
  // };


  const GetResponseMatpels = async (selectedBranchId = "") => {
  if (!selectedBranchId) {
    setGetMatpel([]);
    return;
  }

  try {
    const response = await APISD.get(`/api/matpels`, {
      ...fetchParams,
      params: {
        page: 1,
        limit: 10000,
        ascending: ascending,
        search: "",
        ysb_branch_id: selectedBranchId,
      },

      // kalau endpoint GET ini baca body seperti Postman
      data: {
        page: 1,
        limit: 10000,
        ascending: ascending,
        search: "",
        ysb_branch_id: selectedBranchId,
      },
    });

    const rows = response?.data?.data || [];

    setGetMatpel(
      rows.sort((a, b) =>
        String(a?.name_matpel || "").localeCompare(
          String(b?.name_matpel || ""),
          "id",
          {
            numeric: true,
            sensitivity: "base",
          }
        )
      )
    );
  } catch (error) {
    console.error("Gagal mengambil data matpel:", error);
    setGetMatpel([]);

    ToastError.fire({
      icon: "error",
      title: "Gagal mengambil data mata pelajaran",
    });
  }
};

  const sortByLevelName = (a, b) => {
    const nameA = Number(a?.name_level);
    const nameB = Number(b?.name_level);

    if (!isNaN(nameA) && !isNaN(nameB)) {
      return nameA - nameB;
    }

    return String(a?.name_level || "").localeCompare(
      String(b?.name_level || ""),
      "id",
      { numeric: true }
    );
  };

  const sortByKelasName = (a, b) => {
    const nameA = a?.name_kelas || a?.kelas_name || a?.name || "";
    const nameB = b?.name_kelas || b?.kelas_name || b?.name || "";

    return String(nameA).localeCompare(String(nameB), "id", {
      numeric: true,
      sensitivity: "base",
    });
  };

  const getGradeIdFromKelas = (kelas) => {
    return (
      kelas?.ysb_grade_level_id ||
      kelas?.grade_level_id ||
      kelas?.gradeLevelId ||
      kelas?.grade_level?.id ||
      kelas?.ysb_grade_level?.id ||
      ""
    );
  };

  const getKelasName = (kelas) => {
    return kelas?.name_kelas || kelas?.kelas_name || kelas?.name || "-";
  };

  const getGradeLevelsAndKelas = async (selectedBranchId) => {
    if (!selectedBranchId) {
      setGradeLevels([]);
      setKelasList([]);
      return;
    }

    try {
      setLoading(true);

      const [gradeResponse, kelasResponse] = await Promise.all([
        APIMS.get(
          `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${selectedBranchId}&level=${storageLevel}`,
          fetchParams
        ),
        APIMS.get(
          `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${selectedBranchId}&level=${storageLevel}`,
          fetchParams
        ),
      ]);

      const dataGrade = gradeResponse?.data?.data || [];
      const dataKelas = kelasResponse?.data?.data || [];

      const filteredGrade = dataGrade
        .filter((item) => {
          const branchValue =
            item?.ysb_branch_id ||
            item?.branch ||
            item?.branch_code ||
            item?.branch_id;

          return !branchValue || branchValue === selectedBranchId;
        })
        .sort(sortByLevelName);

      const filteredKelas = dataKelas
        .filter((item) => {
          const branchValue =
            item?.ysb_branch_id ||
            item?.branch ||
            item?.branch_code ||
            item?.branch_id;

          return !branchValue || branchValue === selectedBranchId;
        })
        .sort(sortByKelasName);

      setGradeLevels(filteredGrade);
      setKelasList(filteredKelas);
    } catch (error) {
      console.error("Gagal mengambil data tingkatan / kelas:", error);
      setGradeLevels([]);
      setKelasList([]);

      ToastError.fire({
        icon: "error",
        title: "Gagal mengambil data tingkatan / kelas",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetResponseCabang();
  }, []);

  //  useEffect(() => {
  //   GetResponseMatpels();
  // }, []);

  useEffect(() => {
    setGetMatpel([]);
  }, []);

  // const handleChange = async (e) => {
  //   const { name, value } = e.target;

  //   // if (name === "ysb_branch_id") {
  //   //   setForm((prev) => ({
  //   //     ...prev,
  //   //     ysb_branch_id: value,
  //   //     ysb_grade_level_id: [],
  //   //     ysb_kelas_id: [],
  //   //   }));

  //   //   getGradeLevelsAndKelas(value);
  //   //   return;
  //   // }

  //   if (name === "ysb_branch_id") {
  //     setForm((prev) => ({
  //       ...prev,
  //       ysb_branch_id: value,
  //       name_matpel: "",
  //       ysb_grade_level_id: [],
  //       ysb_kelas_id: [],
  //     }));

  //     setGetMatpel([]);

  //     getGradeLevelsAndKelas(value);
  //     GetResponseMatpels(value);

  //     return;
  //   }

  //   setForm((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  // const getKelasByGradeId = (gradeId) => {
  //   return kelasList.filter((kelas) => getGradeIdFromKelas(kelas) === gradeId);
  // };

    const handleChange = async (e) => {
    const { name, value } = e.target;

    if (name === "ysb_branch_id") {
      setForm((prev) => ({
        ...prev,
        ysb_branch_id: value,
        name_matpel: "",
        ysb_grade_level_id: [],
        ysb_kelas_id: [],
      }));

      setGetMatpel([]);

      getGradeLevelsAndKelas(value);
      GetResponseMatpels(value);

      return;
    }

    if (name === "name_matpel") {
      setForm((prev) => {
        const selectedKelasFiltered = (prev.ysb_kelas_id || []).filter(
          (kelasId) => !isKelasAlreadyRegistered(kelasId, value)
        );

        const selectedGradeFiltered = (prev.ysb_grade_level_id || []).filter(
          (gradeId) => {
            const kelasDalamGrade = getKelasByGradeId(gradeId).map(
              (kelas) => kelas?.id
            );

            return kelasDalamGrade.some((kelasId) =>
              selectedKelasFiltered.includes(kelasId)
            );
          }
        );

        return {
          ...prev,
          name_matpel: value,
          ysb_kelas_id: selectedKelasFiltered,
          ysb_grade_level_id: selectedGradeFiltered,
        };
      });

      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const getKelasByGradeId = (gradeId) => {
  return kelasList.filter(
    (kelas) => String(getGradeIdFromKelas(kelas)) === String(gradeId)
  );
};

  const getMatpelNameById = (matpelId) => {
    const selected = getDataMatpel.find(
      (item) => String(item?.id) === String(matpelId)
    );

    return selected?.name_matpel || "";
  };

  const isSameMatpel = (configRow, selectedMatpelId) => {
    if (!selectedMatpelId) return false;

    const selectedMatpelName = getMatpelNameById(selectedMatpelId)
      .toLowerCase()
      .trim();

    const rowMatpelId = configRow?.ysb_matpel_id || configRow?.id || "";
    const rowMatpelName = String(configRow?.name_matpel || "")
      .toLowerCase()
      .trim();

    return (
      String(rowMatpelId) === String(selectedMatpelId) ||
      (!!selectedMatpelName && rowMatpelName === selectedMatpelName)
    );
  };

  const isConfigKelasStillActive = (kelas) => {
  // kalau kelas langsung punya state_form
  if (kelas?.state_form !== undefined && kelas?.state_form !== null) {
    return String(kelas?.state_form) === "1";
  }

  // kalau state_form ada di semester
  const semesters = kelas?.semesters || [];

  if (semesters.length > 0) {
    return semesters.some(
      (semester) => String(semester?.state_form) === "1"
    );
  }

  // fallback untuk data lama yang tidak punya state_form
  return true;
};

  // const isKelasAlreadyRegistered = (kelasId, selectedMatpelId = form.name_matpel) => {
  //   if (!selectedMatpelId || !kelasId) return false;

  //   return (props?.existingConfigMatpels || []).some((matpel) => {
  //     if (!isSameMatpel(matpel, selectedMatpelId)) return false;

  //     return (matpel?.grade_levels || []).some((level) => {
  //       return (level?.kelas || []).some(
  //         (kelas) => String(kelas?.ysb_kelas_id) === String(kelasId)
  //       );
  //     });
  //   });
  // };

  const isKelasAlreadyRegistered = (
  kelasId,
  selectedMatpelId = form.name_matpel
) => {
  if (!selectedMatpelId || !kelasId) return false;

  return (props?.existingConfigMatpels || []).some((matpel) => {
    if (!isSameMatpel(matpel, selectedMatpelId)) return false;

    return (matpel?.grade_levels || []).some((level) => {
      return (level?.kelas || []).some((kelas) => {
        const registeredKelasId =
          kelas?.ysb_kelas_id ||
          kelas?.kelas_id ||
          kelas?.id ||
          "";

        if (String(registeredKelasId) !== String(kelasId)) {
          return false;
        }

        // ✅ ini bagian penting:
        // kelas hanya dianggap sudah terdaftar kalau masih aktif
        return isConfigKelasStillActive(kelas);
      });
    });
  });
};

  const getSelectableKelasByGradeId = (gradeId, selectedMatpelId = form.name_matpel) => {
    return getKelasByGradeId(gradeId).filter(
      (kelas) => !isKelasAlreadyRegistered(kelas?.id, selectedMatpelId)
    );
  };

  // const handleCheckTingkatan = (gradeId) => {
  //   setForm((prev) => {
  //     const kelasDalamTingkatan = getKelasByGradeId(gradeId).map(
  //       (kelas) => kelas?.id
  //     );

  //     const isChecked = prev.ysb_grade_level_id.includes(gradeId);

  //     if (isChecked) {
  //       return {
  //         ...prev,
  //         ysb_grade_level_id: prev.ysb_grade_level_id.filter(
  //           (id) => id !== gradeId
  //         ),
  //         ysb_kelas_id: prev.ysb_kelas_id.filter(
  //           (id) => !kelasDalamTingkatan.includes(id)
  //         ),
  //       };
  //     }

  //     return {
  //       ...prev,
  //       ysb_grade_level_id: [...prev.ysb_grade_level_id, gradeId],
  //       ysb_kelas_id: Array.from(
  //         new Set([...prev.ysb_kelas_id, ...kelasDalamTingkatan])
  //       ),
  //     };
  //   });
  // };

    const handleCheckTingkatan = (gradeId) => {
    setForm((prev) => {
      const kelasDalamTingkatan = getSelectableKelasByGradeId(
        gradeId,
        prev.name_matpel
      ).map((kelas) => kelas?.id);

      if (kelasDalamTingkatan.length === 0) {
        return prev;
      }

      const isAllChecked = kelasDalamTingkatan.every((id) =>
        prev.ysb_kelas_id.includes(id)
      );

      if (isAllChecked) {
        const newKelasId = prev.ysb_kelas_id.filter(
          (id) => !kelasDalamTingkatan.includes(id)
        );

        return {
          ...prev,
          ysb_grade_level_id: prev.ysb_grade_level_id.filter(
            (id) => id !== gradeId
          ),
          ysb_kelas_id: newKelasId,
        };
      }

      return {
        ...prev,
        ysb_grade_level_id: Array.from(
          new Set([...prev.ysb_grade_level_id, gradeId])
        ),
        ysb_kelas_id: Array.from(
          new Set([...prev.ysb_kelas_id, ...kelasDalamTingkatan])
        ),
      };
    });
  };

  // const handleCheckKelas = (kelasId, gradeId) => {
  //   setForm((prev) => {
  //     const isChecked = prev.ysb_kelas_id.includes(kelasId);

  //     const newKelasId = isChecked
  //       ? prev.ysb_kelas_id.filter((id) => id !== kelasId)
  //       : [...prev.ysb_kelas_id, kelasId];

  //     const kelasDalamTingkatan = getKelasByGradeId(gradeId).map(
  //       (kelas) => kelas?.id
  //     );

  //     const stillHasSelectedKelasInGrade = kelasDalamTingkatan.some((id) =>
  //       newKelasId.includes(id)
  //     );

  //     const newGradeLevelId = stillHasSelectedKelasInGrade
  //       ? Array.from(new Set([...prev.ysb_grade_level_id, gradeId]))
  //       : prev.ysb_grade_level_id.filter((id) => id !== gradeId);

  //     return {
  //       ...prev,
  //       ysb_kelas_id: newKelasId,
  //       ysb_grade_level_id: newGradeLevelId,
  //     };
  //   });
  // };

  // const handleSubmit = useMutation(async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);

  //   try {
  //     const response = await APIMS.post(
  //       "/api/matpels/store",
  //       {
  //         name_matpel: form?.name_matpel,
  //         ysb_branch_id: form?.ysb_branch_id,
  //         ysb_grade_level_id: form?.ysb_grade_level_id,
  //         ysb_kelas_id: form?.ysb_kelas_id,
  //         user_id: id_user,
  //       },
  //       fetchParams
  //     );

  //     if (response.status === 201 || response.status === 200) {
  //       ToastSuccess.fire({
  //         icon: "success",
  //         title: response.data.message || "Data berhasil disimpan",
  //       });

  //       props.GetResponseData();
  //       props.onHide();
  //     }
  //   } catch (error) {
  //     ToastError.fire({
  //       icon: "error",
  //       title: error.response?.data?.message || "Gagal menyimpan data",
  //     });
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // });

//   const handleSubmit = useMutation(async (e) => {
//   e.preventDefault();

//   if (!form?.ysb_branch_id) {
//     ToastError.fire({
//       icon: "error",
//       title: "Cabang wajib dipilih",
//     });
//     return;
//   }

//   if (!form?.name_matpel?.trim()) {
//     ToastError.fire({
//       icon: "error",
//       title: "Nama mata pelajaran wajib diisi",
//     });
//     return;
//   }

//   if (!form?.ysb_kelas_id || form.ysb_kelas_id.length === 0) {
//     ToastError.fire({
//       icon: "error",
//       title: "Pilih minimal satu kelas",
//     });
//     return;
//   }

//   setIsSubmitting(true);

//   try {
//     const payload = {
//       ysb_branch_id: form?.ysb_branch_id,
//       name_matpel: form?.name_matpel,
//       state_form: 1,
//       user_id: id_user,

//       // ini berisi ID kelas yang dicentang user
//       kelas_ids: form?.ysb_kelas_id,
//     };

//     const response = await APISD.post(
//       "/api/matpels/store",
//       payload,
//       fetchParams
//     );

//     if (response.status === 201 || response.status === 200) {
//       ToastSuccess.fire({
//         icon: "success",
//         title: response.data.message || "Data berhasil disimpan",
//       });

//       setForm({
//         ysb_branch_id: "",
//         name_matpel: "",
//         ysb_grade_level_id: [],
//         ysb_kelas_id: [],
//         user_id: "",
//       });

//       setGradeLevels([]);
//       setKelasList([]);

//       props.GetResponseData();
//       props.onHide();
//     }
//   } catch (error) {
//     console.error("Gagal menyimpan mata pelajaran:", error?.response || error);

//     ToastError.fire({
//       icon: "error",
//       title:
//         error.response?.data?.message ||
//         "Gagal menyimpan mata pelajaran",
//     });
//   } finally {
//     setIsSubmitting(false);
//   }
// });


// const handleSubmit = useMutation(async (e) => {
//   e.preventDefault();

//   if (!form?.ysb_branch_id) {
//     ToastError.fire({
//       icon: "error",
//       title: "Cabang wajib dipilih",
//     });
//     return;
//   }

//   if (!form?.name_matpel?.trim()) {
//     ToastError.fire({
//       icon: "error",
//       title: "Mata pelajaran wajib dipilih",
//     });
//     return;
//   }

//   if (!form?.ysb_kelas_id || form.ysb_kelas_id.length === 0) {
//     ToastError.fire({
//       icon: "error",
//       title: "Pilih minimal satu kelas",
//     });
//     return;
//   }

//   setIsSubmitting(true);

//   try {
//     const selectedMatpel = getDataMatpel.find(
//       (item) => String(item?.id) === String(form?.name_matpel)
//     );

//     const selectedGradeLevels = gradeLevels.filter((level) =>
//       form?.ysb_grade_level_id.includes(level?.id)
//     );

//     const dummyGradeLevels = selectedGradeLevels.map((level) => {
//       const kelasDalamLevel = kelasList.filter((kelas) => {
//         const kelasGradeId = getGradeIdFromKelas(kelas);

//         return (
//           String(kelasGradeId) === String(level?.id) &&
//           form?.ysb_kelas_id.includes(kelas?.id)
//         );
//       });

//       return {
//         ysb_grade_level_id: level?.id,
//         name_level: level?.name_level || "",
//         kelas: kelasDalamLevel.map((kelas) => ({
//           ysb_kelas_id: kelas?.id,
//           ysb_grade_level_id: level?.id,
//           ysb_school_id: kelas?.ysb_school_id || "",
//           name_kelas: getKelasName(kelas),
//           state_form: 1,
//         })),
//       };
//     });

//     const dummyRow = {
//       id: `dummy-config-${Date.now()}`,
//       ysb_matpel_id: selectedMatpel?.id || form?.name_matpel,
//       name_matpel: selectedMatpel?.name_matpel || form?.name_matpel,
//       ysb_branch_id: form?.ysb_branch_id,
//       state_form: 1,
//       is_dummy: true,
//       grade_levels: dummyGradeLevels,
//     };

//     props.onAddDummyConfig?.(dummyRow);

//     setForm({
//       ysb_branch_id: "",
//       name_matpel: "",
//       ysb_grade_level_id: [],
//       ysb_kelas_id: [],
//       user_id: "",
//     });

//     setGradeLevels([]);
//     setKelasList([]);

//     props.onHide();
//   } catch (error) {
//     console.error("Gagal membuat dummy config matpel:", error);

//     ToastError.fire({
//       icon: "error",
//       title: "Gagal menambahkan dummy config mata pelajaran",
//     });
//   } finally {
//     setIsSubmitting(false);
//   }
// });

// const handleSubmit = useMutation(async (e) => {
//   e.preventDefault();

//   if (!form?.ysb_branch_id) {
//     ToastError.fire({
//       icon: "error",
//       title: "Cabang wajib dipilih",
//     });
//     return;
//   }

//   if (!form?.name_matpel?.trim()) {
//     ToastError.fire({
//       icon: "error",
//       title: "Mata pelajaran wajib dipilih",
//     });
//     return;
//   }

//   if (!form?.ysb_kelas_id || form.ysb_kelas_id.length === 0) {
//     ToastError.fire({
//       icon: "error",
//       title: "Pilih minimal satu kelas",
//     });
//     return;
//   }

//   if (!props?.academicYearId) {
//     ToastError.fire({
//       icon: "error",
//       title: "Tahun ajaran belum tersedia",
//     });
//     return;
//   }

//   setIsSubmitting(true);

//   try {
//     const payload = {
//       ysb_academic_year_id: props.academicYearId,
//       ysb_branch_id: form?.ysb_branch_id,
//       ysb_matpel_id: [form?.name_matpel],
//       ysb_kelas_id: form?.ysb_kelas_id,
//       user_id: id_user,
//     };

//     const response = await APISD.post(
//       "/api/config-matpels/store",
//       payload,
//       fetchParams
//     );

//     if (response.status === 201 || response.status === 200) {
//       ToastSuccess.fire({
//         icon: "success",
//         title: response.data?.message || "Config mata pelajaran berhasil disimpan",
//       });

//       setForm({
//         ysb_branch_id: "",
//         name_matpel: "",
//         ysb_grade_level_id: [],
//         ysb_kelas_id: [],
//         user_id: "",
//       });

//       setGradeLevels([]);
//       setKelasList([]);

//       props.GetResponseData?.();
//       props.onHide?.();
//     }
//   } catch (error) {
//     console.error("Gagal menyimpan config mata pelajaran:", error?.response || error);

//     ToastError.fire({
//       icon: "error",
//       title:
//         error.response?.data?.message ||
//         "Gagal menyimpan config mata pelajaran",
//     });
//   } finally {
//     setIsSubmitting(false);
//   }
// });

  const handleCheckKelas = (kelasId, gradeId) => {
    if (isKelasAlreadyRegistered(kelasId)) {
      return;
    }

    setForm((prev) => {
      const isChecked = prev.ysb_kelas_id.includes(kelasId);

      const newKelasId = isChecked
        ? prev.ysb_kelas_id.filter((id) => id !== kelasId)
        : [...prev.ysb_kelas_id, kelasId];

      const kelasDalamTingkatan = getSelectableKelasByGradeId(
        gradeId,
        prev.name_matpel
      ).map((kelas) => kelas?.id);

      const stillHasSelectedKelasInGrade = kelasDalamTingkatan.some((id) =>
        newKelasId.includes(id)
      );

      const newGradeLevelId = stillHasSelectedKelasInGrade
        ? Array.from(new Set([...prev.ysb_grade_level_id, gradeId]))
        : prev.ysb_grade_level_id.filter((id) => id !== gradeId);

      return {
        ...prev,
        ysb_kelas_id: newKelasId,
        ysb_grade_level_id: newGradeLevelId,
      };
    });
  };

const getSchoolIdFromKelas = (kelas) => {
  return (
    kelas?.ysb_school_id ||
    kelas?.school_id ||
    kelas?.school?.id ||
    ""
  );
};

const getSelectedKelasDetail = () => {
  return kelasList.filter((kelas) =>
    form?.ysb_kelas_id?.some(
      (selectedId) => String(selectedId) === String(kelas?.id)
    )
  );
};

const getSchoolAndGradeFromSelectedKelas = () => {
  const selectedKelas = getSelectedKelasDetail();

  const firstKelas = selectedKelas?.[0];

  return {
    ysb_school_id: getSchoolIdFromKelas(firstKelas),
    ysb_grade_level_id:
      getGradeIdFromKelas(firstKelas) ||
      form?.ysb_grade_level_id?.[0] ||
      "",
  };
};

const handleSubmit = useMutation(async (e) => {
  e.preventDefault();

  const selectedAcademicYearId = props?.academicYearId;
  const selectedUserId = id_user || localStorage.getItem("user_id") || localStorage.getItem("id");

  if (!selectedAcademicYearId) {
    ToastError.fire({
      icon: "error",
      title: "Tahun ajaran belum tersedia",
    });
    return;
  }

  if (!form?.ysb_branch_id) {
    ToastError.fire({
      icon: "error",
      title: "Cabang wajib dipilih",
    });
    return;
  }

  if (!form?.name_matpel) {
    ToastError.fire({
      icon: "error",
      title: "Mata pelajaran wajib dipilih",
    });
    return;
  }

  if (!form?.ysb_kelas_id || form.ysb_kelas_id.length === 0) {
    ToastError.fire({
      icon: "error",
      title: "Pilih minimal satu kelas",
    });
    return;
  }

  if (!selectedUserId) {
    ToastError.fire({
      icon: "error",
      title: "User ID belum tersedia. Silakan login ulang.",
    });
    return;
  }

  const { ysb_school_id, ysb_grade_level_id } =
  getSchoolAndGradeFromSelectedKelas();

if (!ysb_school_id) {
  ToastError.fire({
    icon: "error",
    title: "School ID belum tersedia dari data kelas",
  });
  return;
}

if (!ysb_grade_level_id) {
  ToastError.fire({
    icon: "error",
    title: "Grade level ID belum tersedia dari data kelas",
  });
  return;
}

  setIsSubmitting(true);

  try {
    // const payload = {
    //   ysb_academic_year_id: selectedAcademicYearId,
    //   ysb_branch_id: form.ysb_branch_id,
    //   ysb_matpel_id: [form.name_matpel],
    //   ysb_kelas_id: form.ysb_kelas_id,
    //   user_id: selectedUserId,
    // };

    const payload = {
  ysb_academic_year_id: selectedAcademicYearId,
  ysb_branch_id: form.ysb_branch_id,
  ysb_school_id: ysb_school_id,
  ysb_grade_level_id: ysb_grade_level_id,
  ysb_matpel_id: [form.name_matpel],
  ysb_kelas_id: form.ysb_kelas_id,
  user_id: selectedUserId,
};

    console.log("PAYLOAD STORE CONFIG MATPEL:", payload);

    const response = await APISD.post(
      "/api/config-matpels/store",
      payload,
      fetchParams
    );

    console.log("RESPONSE STORE CONFIG MATPEL:", response?.data);

    if (
      response?.status === 201 ||
      response?.status === 200 ||
      response?.data?.status === 201
    ) {
      if (response?.data?.error === false || response?.data?.error === undefined) {
        ToastSuccess.fire({
          icon: "success",
          title:
            response?.data?.message ||
            "Konfigurasi mata pelajaran berhasil disimpan",
        });

        setForm({
          ysb_branch_id: "",
          name_matpel: "",
          ysb_grade_level_id: [],
          ysb_kelas_id: [],
          user_id: "",
        });

        setGetMatpel([]);
        setGradeLevels([]);
        setKelasList([]);

        props.GetResponseData?.();
        props.onHide?.();

        return;
      }
    }

    ToastError.fire({
      icon: "error",
      title:
        response?.data?.message ||
        "Gagal menyimpan konfigurasi mata pelajaran",
    });
  } catch (error) {
    console.error("ERROR STORE CONFIG MATPEL:", error);
    console.error("ERROR RESPONSE:", error?.response?.data);

    ToastError.fire({
      icon: "error",
      title:
        error?.response?.data?.message ||
        "Gagal menyimpan konfigurasi mata pelajaran",
    });
  } finally {
    setIsSubmitting(false);
  }
});

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  const toTitleCase = (value) => {
      const s = safeStr(value).toLowerCase().trim();
      if (!s) return "";
      return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

  return (
    <Modal
      {...props}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="module-modal-dialog module-modal-dialog-lg"
      contentClassName="module-modal-content"
    >
      <style>{css}</style>

      <Form onSubmit={(event) => handleSubmit.mutate(event)}>
        <div className="module-modal-header">
          <div>
            <h5 className="module-modal-title">Tambah Matpel Kelas</h5>
            
          </div>

          <button
            type="button"
            className="module-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <Modal.Body className="module-modal-body mt-1 mx-2">
          <div className="module-form-grid">
            <div className="module-form-group">
              <label className="module-form-label" htmlFor="add-academic-year">
                Tahun Ajaran <span>*</span>
              </label>

              <select
                id="add-academic-year"
                className="module-form-select"
                value={props?.academicYearId || ""}
                onChange={(event) => {
                  const selected = props?.academicYears?.find(
                    (item) => String(item?.id) === String(event.target.value)
                  );

                  props?.onChangeAcademicYear?.(
                    event.target.value,
                    selected?.name_year || selected?.name || ""
                  );
                }}
                disabled
              >
                <option value="" hidden>
                  Pilih Tahun Ajaran
                </option>

                {(props?.academicYears || []).map((item, index) => (
                  <option key={item?.id || index} value={item?.id}>
                    {item?.name_year || item?.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="module-form-group">
              <label className="module-form-label" htmlFor="add-branch">
                Cabang <span>*</span>
              </label>

              <select
                id="add-branch"
                className="module-form-select"
                onChange={handleChange}
                name="ysb_branch_id"
                value={ysb_branch_id}
                disabled={isSubmitting}
                required
              >
                <option value="" hidden>
                  Pilih Cabang
                </option>

                {getDataCabang.map((cabang, index) => (
                  <option key={index} value={cabang?.branch_code}>
                    {cabang?.branch_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="module-form-group module-form-span-2">
              <label className="module-form-label" htmlFor="add-matpel">
                Mata Pelajaran <span>*</span>
              </label>

              <select
                id="add-matpel"
                className="module-form-select"
                onChange={handleChange}
                name="name_matpel"
                value={name_matpel}
                disabled={isSubmitting || !ysb_branch_id}
                required
              >
                <option value="" hidden>
                  Pilih Mata Pelajaran
                </option>

                {getDataMatpel.map((matpel, index) => (
                  <option key={index} value={matpel?.id}>
                    {matpel?.name_matpel}
                  </option>
                ))}
              </select>
            </div>

            <div className="module-form-group module-form-span-2">
              <label className="module-form-label">
                Tingkatan dan Kelas <span>*</span>
              </label>

              <div className="matpel-grade-panel">
                {!ysb_branch_id ? (
                  <div className="matpel-form-helper">
                    Silakan pilih cabang terlebih dahulu.
                  </div>
                ) : loading ? (
                  <div className="matpel-form-helper">
                    Memuat data tingkatan dan kelas...
                  </div>
                ) : gradeLevels.length === 0 ? (
                  <div className="matpel-form-helper">
                    Tingkatan tidak ditemukan untuk cabang ini.
                  </div>
                ) : (
                  <div className="tingkatan-kelas-wrapper">
                    {gradeLevels.map((tingkatan) => {
                      const gradeId = tingkatan?.id;
                      const kelasByGrade = getKelasByGradeId(gradeId);
                      const selectableKelas = getSelectableKelasByGradeId(gradeId);
                      const isTingkatanDisabled =
                        !name_matpel || selectableKelas.length === 0;
                      const isTingkatanChecked =
                        selectableKelas.length > 0 &&
                        selectableKelas.every((kelas) =>
                          ysb_kelas_id.includes(kelas?.id)
                        );

                      return (
                        <div className="tingkatan-box" key={gradeId}>
                          <label
                            className={`tingkatan-parent ${
                              isTingkatanDisabled ? "disabled-kelas" : ""
                            }`}
                          >
                            <input
                              type="checkbox"
                              checked={isTingkatanChecked}
                              disabled={isTingkatanDisabled || isSubmitting}
                              onChange={() => handleCheckTingkatan(gradeId)}
                            />
                            <span>Kelas {tingkatan?.name_level}</span>
                          </label>

                          {kelasByGrade.length > 0 && (
                            <div className="kelas-child-wrapper">
                              {kelasByGrade.map((kelas) => {
                                const kelasId = kelas?.id;
                                const alreadyRegistered =
                                  isKelasAlreadyRegistered(kelasId);
                                const isDisabled =
                                  !name_matpel || alreadyRegistered;

                                return (
                                  <label
                                    className={`kelas-child ${
                                      isDisabled ? "disabled-kelas" : ""
                                    }`}
                                    key={kelasId}
                                    title={
                                      alreadyRegistered
                                        ? "Mata pelajaran ini sudah terdaftar di kelas ini"
                                        : ""
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={ysb_kelas_id.includes(kelasId)}
                                      disabled={isDisabled || isSubmitting}
                                      onChange={() =>
                                        handleCheckKelas(kelasId, gradeId)
                                      }
                                    />

                                    <span>
                                      {tingkatan?.name_level}{" "}
                                      {toTitleCase(getKelasName(kelas))}
                                      {alreadyRegistered && (
                                        <span className="badge-sudah-terdaftar">
                                          Sudah terdaftar
                                        </span>
                                      )}
                                    </span>
                                  </label>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>

        <div className="module-modal-footer">
          <button
            type="button"
            className="module-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="module-modal-submit"
            disabled={
              isSubmitting ||
              loading ||
              !ysb_branch_id ||
              !name_matpel?.trim() ||
              ysb_kelas_id.length === 0
            }
          >
            {isSubmitting && <span className="module-button-spinner" />}
            {isSubmitting ? "Menyimpan..." : "Tambahkan"}
          </button>
        </div>
      </Form>
    </Modal>
  );
}
